import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Row, Card, Col, Button } from 'antd';
import { BellOutlined, EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { subscriptionInfo } from '../listContent/subscriptionInfo';
import { DescriptionList } from '../../../../../components';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

const SubscriptionInfoCards = ({
  isLoading,
  subscription,
  setSubscriptionDrawerOpen,
  subscriptionInvoice,
  setSubscriptonInfoModalOpen,
  setIsEmailModalOpen,
  setTemplateType,
  setDocumentType
}) => {
  const { t } = useTranslation();

  return (
    <Card
      title={
        <CardTitle icon="euro">
          {t('pensioners.show.subscription_info')}
        </CardTitle>
      }
      className="subscription-info-card"
      extra={
        <Row>
          {Object.keys(subscription).length ? (
            <Col>
              <Button
                type="link"
                style={{ color: 'var(--errorColor)' }}
                onClick={() => {
                  setIsEmailModalOpen(true);
                  setTemplateType('SEND_SUBSCRIPTION_REMINDER');
                  setDocumentType('SUBSCRIPTION-INVOICE');
                }}
              >
                <BellOutlined />
              </Button>
            </Col>
          ) : null}
          <Col>
            <Button
              type="link"
              onClick={() =>
                ['PAID', 'FREE'].includes(subscriptionInvoice.status) ||
                Object.keys(subscription).length === 0
                  ? setSubscriptionDrawerOpen(true)
                  : setSubscriptonInfoModalOpen(true)
              }
            >
              <EditOutlined />
            </Button>
          </Col>
        </Row>
      }
    >
      <Row gutter={[0, 24]}>
        <Col xs={24} xxl={24}>
          <Skeleton active loading={isLoading} paragraph={{ rows: 5 }}>
            {Object.keys(subscription).length ? (
              <DescriptionList
                data={subscriptionInfo(
                  subscription || {},
                  // En chaîne : DescriptionList remplace un 0 numérique par « - »
                  subscriptionInvoice?.total_ttc?.toString() ?? '-',
                  subscriptionInvoice?.status &&
                    t(`customerinvoices.tags.${subscriptionInvoice.status}`)
                )}
                translate
              />
            ) : null}
          </Skeleton>
        </Col>
      </Row>
    </Card>
  );
};

export default SubscriptionInfoCards;

SubscriptionInfoCards.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  subscription: PropTypes.shape({}).isRequired,
  setSubscriptionDrawerOpen: PropTypes.func.isRequired,
  subscriptionInvoice: PropTypes.shape({
    total_ttc: PropTypes.number,
    status: PropTypes.string
  }).isRequired,
  setSubscriptonInfoModalOpen: PropTypes.func.isRequired,
  setIsEmailModalOpen: PropTypes.func.isRequired,
  setTemplateType: PropTypes.func.isRequired,
  setDocumentType: PropTypes.func.isRequired
};
